import i18n from '../../../utils/i18n';
import { ChartLegendProps } from '../components/ChartLegend/ChartLegend';
import { HealthSummaryGenericStyles } from './HealthSummary';

export const getLegendItems = (): ChartLegendProps => ({
  items: [
    {
      label: i18n.t('healthSummary.breakdown.myNetwork'),
      stroke: '#575BCF',
    },
    {
      label: i18n.t('healthSummary.breakdown.typNetwork'),
      stroke: '#81BB85',
      tooltipText: i18n.t('healthSummary.breakdown.typNetworkInfo'),
    },
  ],
});

export const styles: HealthSummaryGenericStyles = {
  root: 'HealthSummary',
  title: 'HealthSummary__Title',
  menuRow: 'HealthSummary__MenuRow',
  summaryCell: 'HealthSummary__SummaryCell',
};
